import useGameHistory from '../../hooks/useGameHistory';

function formatDate(date) {
  return date.toLocaleDateString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric'
  });
}

export default function GameHistoryModal({ show, onClose, userId, playerName }) {
  const { games, loading } = useGameHistory(show ? userId : null);

  if (!show) return null;

  return (
    <div className="blurred-app-state" onClick={onClose}>
      <div className="modal-card game-history-modal" onClick={e => e.stopPropagation()}>
        <h2>{playerName}'s games</h2>

        {loading && <p className="history-loading">loading history...</p>}

        {!loading && games.length === 0 && (
          <p className="history-empty">No finished games yet. Get rolling!</p>
        )}

        {!loading && games.length > 0 && (
          <div className="history-list">
            {games.map(game => (
              <div key={game.id} className={`history-item ${game.isWin ? 'history-win' : 'history-loss'}`}>
                <div className="history-item-left">
                  {game.gamePhotoUrl ? (
                    <img className="history-game-photo" src={game.gamePhotoUrl} alt="" />
                  ) : (
                    <div className={`history-game-photo history-photo-placeholder ${game.isWin ? 'badge-win' : 'badge-loss'}`}>
                      {game.isWin ? 'W' : 'L'}
                    </div>
                  )}
                </div>
                <div className="history-item-middle">
                  <div className="history-date">{formatDate(game.date)}</div>
                  <div className="history-players">
                    {game.players.map(p => p.name).join(' vs ')}
                  </div>
                  <div className="history-score">Your score: {game.userScore.toLocaleString()}</div>
                </div>
                <div className="history-item-right">
                  <span className={`history-badge ${game.isWin ? 'badge-win' : 'badge-loss'}`}>
                    {game.isWin ? 'WIN' : 'LOSS'}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}

        <button className="btn-bank" style={{ marginTop: 20 }} onClick={onClose}>Close</button>
      </div>
    </div>
  );
}
